const mcc = {};
export {
  mcc as default
};
